module.exports = __webpack_public_path__ + "static/img/result_list.f0114eb7.png";